


















import {Component, Vue} from 'vue-property-decorator'
import Modal from '@/components/common/Modal.vue'
import {Getter, Mutation, Action} from 'vuex-class'
import {Lead, Location, Room} from '@/store/types'
import LoaderButton from '@/components/common/LoaderButton.vue'

@Component({
  components: {
    Modal,
    LoaderButton,
  },
})

export default class InventoryEditRoomOverlay extends Vue {
  @Getter('lead') public lead!: Lead
  @Getter('location') public location!: Location
  @Getter('activeRoom') public activeRoom!: Room
  @Mutation('setInventoryEditRoomOverlay') public setInventoryEditRoomOverlay!: any
  @Mutation('setActiveRoomId') public setActiveRoomId!: any
  @Action('editRoom') public editRoom!: any
  @Action('removeRoom') public removeRoom!: any

  public name = ''
  public loading = false

  public edit() {
    const data = {name: this.name}

    this.loading = true

    this.editRoom(Object.assign({}, this.activeRoom, data)).then((response: Room) => {
      this.setInventoryEditRoomOverlay(false)
      this.setActiveRoomId(0)
      this.loading = false
    })
  }

  public deleteRoom() {
    this.removeRoom(this.activeRoom).then((response: any) => {
      this.setInventoryEditRoomOverlay(false)
      this.setActiveRoomId(0)
    })
  }

  public mounted() {
    this.name = this.activeRoom.name
  }

  public closeOverlay() {
    this.setInventoryEditRoomOverlay(false)
    this.setActiveRoomId(0)
  }
}
